/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum GQL_AltinnEmploymentDurationTypeEnum {
  fast = "fast",
  fastAnsattUtleid = "fastAnsattUtleid",
  midlertidig = "midlertidig",
  midlertidigAnsattSomTilkallingsvikar = "midlertidigAnsattSomTilkallingsvikar",
  midlertidigAnsattUtleid = "midlertidigAnsattUtleid",
}

export enum GQL_AltinnEmploymentEndReasonEnum {
  arbeidsforholdetSkulleAldriVaertRapportert = "arbeidsforholdetSkulleAldriVaertRapportert",
  arbeidsgiverHarSagtOppArbeidstaker = "arbeidsgiverHarSagtOppArbeidstaker",
  arbeidstakerHarSagtOppSelv = "arbeidstakerHarSagtOppSelv",
  byttetLoenssystemEllerRegnskapsfoerer = "byttetLoenssystemEllerRegnskapsfoerer",
  endringIOrganisasjonsstrukturEllerByttetJobbInternt = "endringIOrganisasjonsstrukturEllerByttetJobbInternt",
  kontraktEngasjementEllerVikariatErUtloept = "kontraktEngasjementEllerVikariatErUtloept",
}

export enum GQL_AltinnEmploymentTypeEnum {
  frilanserOppdragstakerHonorarPersonerMm = "frilanserOppdragstakerHonorarPersonerMm",
  maritimtArbeidsforhold = "maritimtArbeidsforhold",
  ordinaertArbeidsforhold = "ordinaertArbeidsforhold",
  pensjonOgAndreTyperYtelserUtenAnsettelsesforhold = "pensjonOgAndreTyperYtelserUtenAnsettelsesforhold",
}

export enum GQL_AltinnFordelEnum {
  kontantytelse = "kontantytelse",
  naturalytelse = "naturalytelse",
  utgiftsgodtgjoerelse = "utgiftsgodtgjoerelse",
}

export enum GQL_AltinnIncomeDescriptionEnum {
  administrativForpleining = "administrativForpleining",
  aksjerGrunnfondsbevisTilUnderkurs = "aksjerGrunnfondsbevisTilUnderkurs",
  annet = "annet",
  arbeidsoppholdKost = "arbeidsoppholdKost",
  arbeidsoppholdLosji = "arbeidsoppholdLosji",
  bedriftsbarnehageplass = "bedriftsbarnehageplass",
  beregnetSkatt = "beregnetSkatt",
  besoeksreiserHjemmetAnnet = "besoeksreiserHjemmetAnnet",
  besoeksreiserHjemmetKilometergodtgjoerelseBil = "besoeksreiserHjemmetKilometergodtgjoerelseBil",
  besoeksreiserHjemmetKost = "besoeksreiserHjemmetKost",
  betaltUtenlandskSkatt = "betaltUtenlandskSkatt",
  bil = "bil",
  bolig = "bolig",
  bonus = "bonus",
  bonusFraForsvaret = "bonusFraForsvaret",
  elektroniskKommunikasjon = "elektroniskKommunikasjon",
  fastBilgodtgjoerelse = "fastBilgodtgjoerelse",
  fastTillegg = "fastTillegg",
  fastloenn = "fastloenn",
  feriepenger = "feriepenger",
  flyttegodtgjoerelse = "flyttegodtgjoerelse",
  fondForIdrettsutoevere = "fondForIdrettsutoevere",
  friTransport = "friTransport",
  godtgjoerelseSaeravtaleUtland = "godtgjoerelseSaeravtaleUtland",
  helligdagstillegg = "helligdagstillegg",
  honorarAkkordProsentProvisjon = "honorarAkkordProsentProvisjon",
  hyretillegg = "hyretillegg",
  ikkeSkattepliktigLoennFraUtenlandskDiplomKonsulStasjon = "ikkeSkattepliktigLoennFraUtenlandskDiplomKonsulStasjon",
  innbetalingTilUtenlandskPensjonsordning = "innbetalingTilUtenlandskPensjonsordning",
  kapitalInntekt = "kapitalInntekt",
  kilometergodtgjoerelseAndreFremkomstmidler = "kilometergodtgjoerelseAndreFremkomstmidler",
  kilometergodtgjoerelseBil = "kilometergodtgjoerelseBil",
  kilometergodtgjoerelseElBil = "kilometergodtgjoerelseElBil",
  kilometergodtgjoerelsePassasjertillegg = "kilometergodtgjoerelsePassasjertillegg",
  kommunalOmsorgsloennOgFosterhjemsgodtgjoerelse = "kommunalOmsorgsloennOgFosterhjemsgodtgjoerelse",
  kompensasjonstilleggBolig = "kompensasjonstilleggBolig",
  kostDager = "kostDager",
  kostDoegn = "kostDoegn",
  kostbesparelseIHjemmet = "kostbesparelseIHjemmet",
  loennEtterDoedsfall = "loennEtterDoedsfall",
  loennForBarnepassIBarnetsHjem = "loennForBarnepassIBarnetsHjem",
  loennTilPrivatpersonerForArbeidIHjemmet = "loennTilPrivatpersonerForArbeidIHjemmet",
  loennTilVergeFraFylkesmannen = "loennTilVergeFraFylkesmannen",
  loennTilVergeFraStatsforvalteren = "loennTilVergeFraStatsforvalteren",
  loennUtbetaltAvVeldedigEllerAllmennyttigInstitusjonEllerOrganisasjon = "loennUtbetaltAvVeldedigEllerAllmennyttigInstitusjonEllerOrganisasjon",
  loennUtenlandskArtist = "loennUtenlandskArtist",
  losji = "losji",
  losjiEgenBrakkeCampingvogn = "losjiEgenBrakkeCampingvogn",
  opsjoner = "opsjoner",
  overtidsgodtgjoerelse = "overtidsgodtgjoerelse",
  overtidsmat = "overtidsmat",
  reiseAnnet = "reiseAnnet",
  reiseKost = "reiseKost",
  reiseKostMedOvernattingPaaHotell = "reiseKostMedOvernattingPaaHotell",
  reiseKostMedOvernattingPaaHotellBeordringUtover28Doegn = "reiseKostMedOvernattingPaaHotellBeordringUtover28Doegn",
  reiseKostMedOvernattingPaaHybelBrakkePrivat = "reiseKostMedOvernattingPaaHybelBrakkePrivat",
  reiseKostMedOvernattingPaaHybelMedKokEllerPrivat = "reiseKostMedOvernattingPaaHybelMedKokEllerPrivat",
  reiseKostMedOvernattingPaaHybelUtenKokEllerPensjonatEllerBrakke = "reiseKostMedOvernattingPaaHybelUtenKokEllerPensjonatEllerBrakke",
  reiseKostMedOvernattingPaaPensjonat = "reiseKostMedOvernattingPaaPensjonat",
  reiseKostMedOvernattingTilLangtransportsjaafoerForKjoeringIUtlandet = "reiseKostMedOvernattingTilLangtransportsjaafoerForKjoeringIUtlandet",
  reiseKostMedOvernattingTilLangtransportsjaafoerForKjoeringInnenlands = "reiseKostMedOvernattingTilLangtransportsjaafoerForKjoeringInnenlands",
  reiseKostUtenOvernatting = "reiseKostUtenOvernatting",
  reiseLosji = "reiseLosji",
  reiseNattillegg = "reiseNattillegg",
  rentefordelLaan = "rentefordelLaan",
  skattefriErstatning = "skattefriErstatning",
  skattefrieUtbetalinger = "skattefrieUtbetalinger",
  skattepliktigDelForsikringer = "skattepliktigDelForsikringer",
  skattepliktigGodtgjoerelseSaeravtaleUtland = "skattepliktigGodtgjoerelseSaeravtaleUtland",
  skattepliktigPersonalrabatt = "skattepliktigPersonalrabatt",
  sluttvederlag = "sluttvederlag",
  smusstillegg = "smusstillegg",
  stipend = "stipend",
  styrehonorarOgGodtgjoerelseVerv = "styrehonorarOgGodtgjoerelseVerv",
  tilskuddBarnehageplass = "tilskuddBarnehageplass",
  timeloenn = "timeloenn",
  tips = "tips",
  trekkILoennForFerie = "trekkILoennForFerie",
  uregelmessigeTilleggKnyttetTilArbeidetTid = "uregelmessigeTilleggKnyttetTilArbeidetTid",
  uregelmessigeTilleggKnyttetTilIkkeArbeidetTid = "uregelmessigeTilleggKnyttetTilIkkeArbeidetTid",
  yrkebilTjenestligbehovKilometer = "yrkebilTjenestligbehovKilometer",
  yrkebilTjenestligbehovListepris = "yrkebilTjenestligbehovListepris",
}

export enum GQL_AltinnLeaveAndLayoffDescriptionEnum {
  andreIkkeLovfestedePermisjoner = "andreIkkeLovfestedePermisjoner",
  andreLovfestedePermisjoner = "andreLovfestedePermisjoner",
  permisjon = "permisjon",
  permisjonMedForeldrepenger = "permisjonMedForeldrepenger",
  permisjonVedMilitaertjeneste = "permisjonVedMilitaertjeneste",
  permittering = "permittering",
  utdanningspermisjon = "utdanningspermisjon",
  utdanningspermisjonIkkeLovfestet = "utdanningspermisjonIkkeLovfestet",
  utdanningspermisjonLovfestet = "utdanningspermisjonLovfestet",
  velferdspermisjon = "velferdspermisjon",
}

export enum GQL_AltinnShiftTypeEnum {
  andreSkift = "andreSkift",
  doegnkontinuerligSkiftOgTurnus355 = "doegnkontinuerligSkiftOgTurnus355",
  helkontinuerligSkiftOgAndreOrdninger336 = "helkontinuerligSkiftOgAndreOrdninger336",
  ikkeSkift = "ikkeSkift",
  offshore336 = "offshore336",
  skift365 = "skift365",
}

export enum GQL_CompanyNameOptionEnum {
  ALIAS = "ALIAS",
  NAME = "NAME",
}

export enum GQL_InvoiceDeliveryMethodEnum {
  ehf = "ehf",
  email = "email",
  mail = "mail",
  manual = "manual",
}

export enum GQL_NorwegianVatSymbolEnum {
  EXEMPT = "EXEMPT",
  LOW = "LOW",
  REDUCED = "REDUCED",
  REDUCED_FISH = "REDUCED_FISH",
  STANDARD = "STANDARD",
  ZERO = "ZERO",
}

export enum GQL_OrderPDFTypeEnum {
  offer = "offer",
  order = "order",
  orderConfirmation = "orderConfirmation",
  packingSlip = "packingSlip",
}

export enum GQL_OrderStatusEnum {
  CANCELLED = "CANCELLED",
  LOCKED = "LOCKED",
  OPEN = "OPEN",
}

export enum GQL_PaycheckFilterReportedEnum {
  NOT_REPORTED = "NOT_REPORTED",
  REPORTED = "REPORTED",
  SHOULD_REPORT = "SHOULD_REPORT",
}

export enum GQL_PaycheckLineCalculationTypeEnum {
  CALCULATED = "CALCULATED",
  CASHEDOUT = "CASHEDOUT",
}

export enum GQL_PaycheckTaxDeductionMethodEnum {
  MAIN_EMPLOYER_PERCENTAGE = "MAIN_EMPLOYER_PERCENTAGE",
  MAIN_EMPLOYER_TABLE = "MAIN_EMPLOYER_TABLE",
  SECONDARY_EMPLOYER_PERCENTAGE = "SECONDARY_EMPLOYER_PERCENTAGE",
  TAX_EXEMPTION = "TAX_EXEMPTION",
}

export enum GQL_ReportIntervalEnum {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  WEEKLY = "WEEKLY",
  YEARLY = "YEARLY",
}

export enum GQL_RoundingTypeEnum {
  DISABLED = "DISABLED",
  DOWN = "DOWN",
  NEAREST = "NEAREST",
  UP = "UP",
}

export enum GQL_SupplierPartyReferenceSettingEnum {
  FIRST_NAME = "FIRST_NAME",
  FULL_NAME = "FULL_NAME",
  LAST_NAME = "LAST_NAME",
}

export enum GQL_UnitPaycheckSettingsAltinn3SystemUserStatusEnum {
  no_system_user = "no_system_user",
  registered = "registered",
  request_in_progress = "request_in_progress",
  request_rejected = "request_rejected",
}

export enum GQL_WorkRelationTimesheetStatusEnum {
  draft = "draft",
  submitted = "submitted",
}

export interface GQL_AmeldingAccountSelectionSave {
  id?: string | null;
  _destroy?: boolean | null;
  number?: string | null;
  employeeTaxDeduction?: boolean | null;
}

export interface GQL_AmeldingDataInput {
  calendarMonth: string;
  paycheckIds?: string[] | null;
  ameldingWorkRelations?: GQL_AmeldingDataInputTypeAmeldingWorkRelationSend[] | null;
  pensionAmounts?: GQL_AmeldingDataInputTypeAmeldingPensionAmountSend[] | null;
  reimbursements?: GQL_AmeldingDataInputTypeAmeldingReimbursementSend[] | null;
  ameldingToReplaceId?: string | null;
}

export interface GQL_AmeldingDataInputTypeAmeldingPensionAmountSend {
  amount: GQLScalar_Decimal;
  subUnitId: string;
  employerTaxZoneId: string;
}

export interface GQL_AmeldingDataInputTypeAmeldingReimbursementSend {
  amount: GQLScalar_Decimal;
  subUnitId: string;
  employerTaxZoneId: string;
}

export interface GQL_AmeldingDataInputTypeAmeldingWorkRelationSend {
  workRelationId: string;
  subUnitId: string;
  startDate?: GQLScalar_Date | null;
  endDate?: GQLScalar_Date | null;
  endReason?: GQL_AltinnEmploymentEndReasonEnum | null;
  occupationId?: string | null;
  samePositionSince?: GQLScalar_Date | null;
  shiftType?: GQL_AltinnShiftTypeEnum | null;
  employeeId: string;
  employmentType: GQL_AltinnEmploymentTypeEnum;
  employmentPercentage?: GQLScalar_Decimal | null;
  employmentPercentageUpdated?: GQLScalar_Date | null;
  hoursEveryWeekWithFullEmployment?: GQLScalar_Decimal | null;
  lastSalaryChange?: GQLScalar_Date | null;
  durationType?: GQL_AltinnEmploymentDurationTypeEnum | null;
}

export interface GQL_AppSettingsSave {
  altinnPensionUnitIds?: string[] | null;
}

export interface GQL_CustomerContactCreate {
  firstName: string;
  lastName: string;
  phone?: string | null;
  email?: string | null;
  jobTitle?: string | null;
  comment?: string | null;
}

export interface GQL_CustomerContactUpdate {
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  jobTitle?: string | null;
  comment?: string | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_CustomerCreate {
  unitId: string;
  deliveryLocations?: GQL_DeliveryLocationSave[] | null;
  creditDays: number;
  reference?: string | null;
  customPhone?: string | null;
  customEmail?: string | null;
  invoiceDeliveryMethod: GQL_InvoiceDeliveryMethodEnum;
  autoSendInvoice?: boolean | null;
  unofficialName?: string | null;
  customerNumber?: string | null;
  ownerId: string;
  customerContacts?: GQL_CustomerContactCreate[] | null;
}

export interface GQL_CustomerFilter {
  unitId?: string | null;
  unitName?: string | null;
  deliveryAddress?: string | null;
  deliveryCity?: string | null;
  deliveryZip?: string | null;
  deliveryCountryName?: string | null;
  creditDays?: number | null;
  reference?: string | null;
  unofficialName?: string | null;
  unitActiveAt?: string | null;
  nameWithAlias?: string | null;
}

export interface GQL_CustomerUpdate {
  unitId?: string | null;
  deliveryLocations?: GQL_DeliveryLocationSave[] | null;
  creditDays?: number | null;
  reference?: string | null;
  customPhone?: string | null;
  customEmail?: string | null;
  invoiceDeliveryMethod?: GQL_InvoiceDeliveryMethodEnum | null;
  autoSendInvoice?: boolean | null;
  unofficialName?: string | null;
  customerNumber?: string | null;
  id: string;
  customerContacts?: GQL_CustomerContactUpdate[] | null;
}

export interface GQL_DeliveryLocationSave {
  id?: string | null;
  address?: string | null;
  additionalAddress?: string | null;
  zip?: string | null;
  city?: string | null;
  countryCode?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_EmployeeCreate {
  firstName: string;
  lastName: string;
  address: string;
  zip: string;
  city: string;
  phone?: string | null;
  phoneCountryCode?: string | null;
  countryCode: string;
  postboxNumber?: string | null;
  postboxPlace?: string | null;
  postboxZip?: string | null;
  postboxCity?: string | null;
  birthDateMismatchReason?: string | null;
  birthDate: GQLScalar_Date;
  bban?: string | null;
  iban?: string | null;
  swift?: string | null;
  vacationMoneyPercentage: GQLScalar_Decimal;
  socialSecurityNumber?: string | null;
  temporarySocialSecurityNumber?: string | null;
  creditDays: number;
  unitId: string;
  user: GQL_UserEmployee;
}

export interface GQL_EmployeeTaxCardEmployeeSave {
  fetchedAt?: GQLScalar_Date | null;
  taxTable?: string | null;
  taxPercentage?: GQLScalar_Decimal | null;
  taxExemption?: boolean | null;
  file?: GQLScalar_FileUpload | null;
  calendarYear?: number | null;
  taxExemptionAmountLimit?: GQLScalar_Decimal | null;
  taxDeductionMethod?: GQL_PaycheckTaxDeductionMethodEnum | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_EmployeeUpdate {
  firstName?: string | null;
  lastName?: string | null;
  address?: string | null;
  zip?: string | null;
  city?: string | null;
  phone?: string | null;
  phoneCountryCode?: string | null;
  countryCode?: string | null;
  postboxNumber?: string | null;
  postboxPlace?: string | null;
  postboxZip?: string | null;
  postboxCity?: string | null;
  birthDateMismatchReason?: string | null;
  birthDate?: GQLScalar_Date | null;
  bban?: string | null;
  iban?: string | null;
  swift?: string | null;
  vacationMoneyPercentage?: GQLScalar_Decimal | null;
  socialSecurityNumber?: string | null;
  temporarySocialSecurityNumber?: string | null;
  creditDays?: number | null;
  id: string;
  employeeTaxCards?: GQL_EmployeeTaxCardEmployeeSave[] | null;
  workRelations?: GQL_WorkRelationEmployeeSave[] | null;
}

export interface GQL_ExistingAttachmentInput {
  id?: string | null;
  signedBlobId?: string | null;
  fileName?: string | null;
  url?: string | null;
}

export interface GQL_IdentityCreate {
  identificatorId: string;
  value: string;
  phoneCode?: string | null;
  countryCode?: string | null;
}

export interface GQL_InvoiceFilter {
  customerId?: string | null;
  number?: string | null;
  customerName?: string | null;
  issueDate?: string | null;
  dueDate?: string | null;
  currency?: string | null;
  payableAmount?: string | null;
  note?: string | null;
}

export interface GQL_InvoicePaymentMethodCreate {
  name: string;
  amount: GQLScalar_Decimal;
}

export interface GQL_MainPaycheckLineTemplateSave {
  id?: string | null;
  number?: number | null;
  active?: boolean | null;
  description?: string | null;
  altinnDescription?: GQL_AltinnIncomeDescriptionEnum | null;
  altinnFordel?: GQL_AltinnFordelEnum | null;
  calculationType?: GQL_PaycheckLineCalculationTypeEnum | null;
  calculatePositive?: boolean | null;
  quantity?: GQLScalar_Decimal | null;
  rate?: GQLScalar_Decimal | null;
  sum?: GQLScalar_Decimal | null;
  carId?: string | null;
  projectId?: string | null;
  departmentId?: string | null;
  carOverwrite?: boolean | null;
  projectOverwrite?: boolean | null;
  departmentOverwrite?: boolean | null;
  taxable?: boolean | null;
  employerTaxable?: boolean | null;
  includeInVacationMoneyBase?: boolean | null;
  taxDeduction?: boolean | null;
  taxDeductionVoluntary?: boolean | null;
  garnishment?: boolean | null;
  garnishmentSamordnet?: boolean | null;
  editableFromEmployeePage?: boolean | null;
  vacationMoneyEarnedInPreviousYear?: boolean | null;
  vacationMoneyEarnedInCurrentYear?: boolean | null;
}

export interface GQL_OccupationSelectionCreate {
  occupationId: string;
  unitId: string;
}

export interface GQL_OrderAllowanceChargeBase {
  id?: string | null;
  orderId?: string | null;
  reason?: string | null;
  percent?: GQLScalar_Decimal | null;
  orderAllowanceChargeLines?: GQL_OrderAllowanceChargeLineBase[] | null;
}

export interface GQL_OrderAllowanceChargeLineBase {
  id?: string | null;
  orderAllowanceChargeId?: string | null;
  amount?: GQLScalar_Decimal | null;
  baseAmount?: GQLScalar_Decimal | null;
  vatRateSymbol?: GQL_NorwegianVatSymbolEnum | null;
  taxPercent?: GQLScalar_Decimal | null;
  _destroy?: boolean | null;
}

export interface GQL_OrderDeliveryBase {
  id?: string | null;
  date?: GQLScalar_Date | null;
  streetName?: string | null;
  additionalStreetName?: string | null;
  city?: string | null;
  zip?: string | null;
  countryCode?: string | null;
}

export interface GQL_OrderFilter {
  number?: string | null;
  customerName?: string | null;
  date?: string | null;
  payableAmount?: string | null;
  status?: GQL_OrderStatusEnum | null;
  currency?: string | null;
  note?: string | null;
}

export interface GQL_OrderLineAllowanceChargeBase {
  id?: string | null;
  orderLineId?: string | null;
  reason?: string | null;
  percent?: GQLScalar_Decimal | null;
  amount?: GQLScalar_Decimal | null;
}

export interface GQL_OrderLineBase {
  id?: string | null;
  orderId?: string | null;
  number?: number | null;
  note?: string | null;
  orderedQuantity?: GQLScalar_Decimal | null;
  quantity?: GQLScalar_Decimal | null;
  unitOfMeasureCode?: string | null;
  lineExtensionAmount?: GQLScalar_Decimal | null;
  taxAmount?: GQLScalar_Decimal | null;
  productId?: string | null;
  productDescription?: string | null;
  productDescriptionEnabled?: boolean | null;
  itemName?: string | null;
  itemDescription?: string | null;
  sellersItemIdentificationId?: string | null;
  vatRateSymbol?: GQL_NorwegianVatSymbolEnum | null;
  taxPercent?: GQLScalar_Decimal | null;
  taxExemptionReason?: string | null;
  priceAmount?: GQLScalar_Decimal | null;
  carId?: string | null;
  projectId?: string | null;
  departmentId?: string | null;
  orderLineAllowanceCharge?: GQL_OrderLineAllowanceChargeBase | null;
  _destroy?: boolean | null;
}

export interface GQL_OrderPartyBase {
  id?: string | null;
  partyIdentificationScheme?: string | null;
  partyIdentification?: string | null;
  name?: string | null;
  unofficialName?: string | null;
  phone?: string | null;
  mobile?: string | null;
  email?: string | null;
  streetName?: string | null;
  additionalStreetName?: string | null;
  city?: string | null;
  zip?: string | null;
  countryCode?: string | null;
  reference?: string | null;
  vatRegulation?: boolean | null;
  foretaksRegisteredSince?: GQLScalar_Date | null;
}

export interface GQL_PaycheckCreate {
  currencyCode: string;
  startDate: GQLScalar_Date;
  endDate: GQLScalar_Date;
  dueDate: GQLScalar_Date;
  companyMunicipalityId: string;
  employeeBban?: string | null;
  employeeIban?: string | null;
  employeeSwift?: string | null;
  paidDate?: GQLScalar_Date | null;
  comment?: string | null;
  internalComment?: string | null;
  journalDate: GQLScalar_Date;
  taxDeductionMethod?: GQL_PaycheckTaxDeductionMethodEnum | null;
  taxExemptionAmountLimit?: GQLScalar_Decimal | null;
  shouldSendToAltinn: boolean;
  shouldSendToFakturabank: boolean;
  unitId: string;
  workRelationId: string;
  paycheckLines: GQL_PaycheckLineCreate[];
  prepayments?: GQL_PaycheckPrepaymentCreate[] | null;
  periodId: string;
  number?: number | null;
  advancedMode: boolean;
}

export interface GQL_PaycheckDraftLineSave {
  id?: string | null;
  _destroy?: boolean | null;
  paycheckLineTemplateId?: string | null;
  quantity?: GQLScalar_Decimal | null;
  rate?: GQLScalar_Decimal | null;
  sum?: GQLScalar_Decimal | null;
  carId?: string | null;
  projectId?: string | null;
  departmentId?: string | null;
  carOverwrite?: boolean | null;
  projectOverwrite?: boolean | null;
  departmentOverwrite?: boolean | null;
}

export interface GQL_PaycheckDraftSave {
  id?: string | null;
  workRelationId?: string | null;
  periodId?: string | null;
  active?: boolean | null;
  comment?: string | null;
  paycheckDraftLines?: GQL_PaycheckDraftLineSave[] | null;
}

export interface GQL_PaycheckFilter {
  number?: string | null;
  journalDate?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  employeeName?: string | null;
  paidDate?: string | null;
  reported?: GQL_PaycheckFilterReportedEnum | null;
  reportedDate?: string | null;
  locked?: boolean | null;
  advancedMode?: boolean | null;
  shouldSendToAltinn?: boolean | null;
  shouldSendToFakturabank?: boolean | null;
}

export interface GQL_PaycheckLineBaseAltinnAdditional {
  carAndBoat?: GQL_PaycheckLineBaseAltinnCarAndBoat | null;
}

export interface GQL_PaycheckLineBaseAltinnCarAndBoat {
  listPriceForCar?: GQLScalar_Decimal | null;
  carRegistrationNumber?: string | null;
}

export interface GQL_PaycheckLineCreate {
  paycheckLineTemplateId: string;
  quantity: GQLScalar_Decimal;
  rate: GQLScalar_Decimal;
  sum: GQLScalar_Decimal;
  carId?: string | null;
  projectId?: string | null;
  departmentId?: string | null;
  altinnAdditional?: GQL_PaycheckLineBaseAltinnAdditional | null;
}

export interface GQL_PaycheckLineTemplateUpdate {
  id?: string | null;
  mainPaycheckLineTemplateId?: string | null;
  workRelationId?: string | null;
  active?: boolean | null;
  quantity?: GQLScalar_Decimal | null;
  rate?: GQLScalar_Decimal | null;
  sum?: GQLScalar_Decimal | null;
  carId?: string | null;
  projectId?: string | null;
  departmentId?: string | null;
  carOverwrite?: boolean | null;
  projectOverwrite?: boolean | null;
  departmentOverwrite?: boolean | null;
}

export interface GQL_PaycheckLineUpdate {
  paycheckLineTemplateId?: string | null;
  quantity?: GQLScalar_Decimal | null;
  rate?: GQLScalar_Decimal | null;
  sum?: GQLScalar_Decimal | null;
  carId?: string | null;
  projectId?: string | null;
  departmentId?: string | null;
  altinnAdditional?: GQL_PaycheckLineBaseAltinnAdditional | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_PaycheckPeriodSave {
  id?: string | null;
  name?: string | null;
  bookkeepingPeriod?: string | null;
  isLocked?: boolean | null;
  startDate?: GQLScalar_Date | null;
  endDate?: GQLScalar_Date | null;
  journalDate?: GQLScalar_Date | null;
  _destroy?: boolean | null;
}

export interface GQL_PaycheckPrepaymentCreate {
  amount: GQLScalar_Decimal;
  paymentDate: GQLScalar_Date;
}

export interface GQL_PaycheckPrepaymentUpdate {
  id?: string | null;
  _destroy?: boolean | null;
  amount?: GQLScalar_Decimal | null;
  paymentDate?: GQLScalar_Date | null;
}

export interface GQL_PaycheckUpdate {
  currencyCode?: string | null;
  startDate?: GQLScalar_Date | null;
  endDate?: GQLScalar_Date | null;
  dueDate?: GQLScalar_Date | null;
  companyMunicipalityId?: string | null;
  employeeBban?: string | null;
  employeeIban?: string | null;
  employeeSwift?: string | null;
  paidDate?: GQLScalar_Date | null;
  comment?: string | null;
  internalComment?: string | null;
  journalDate?: GQLScalar_Date | null;
  taxDeductionMethod?: GQL_PaycheckTaxDeductionMethodEnum | null;
  taxExemptionAmountLimit?: GQLScalar_Decimal | null;
  shouldSendToAltinn?: boolean | null;
  shouldSendToFakturabank?: boolean | null;
  id: string;
  paycheckLines?: GQL_PaycheckLineUpdate[] | null;
  prepayments?: GQL_PaycheckPrepaymentUpdate[] | null;
}

export interface GQL_PaymentMethodCreate {
  name: string;
  unitId: string;
}

export interface GQL_PaymentMethodUpdate {
  name?: string | null;
  id: string;
}

export interface GQL_PensionUnitSelectionCreate {
  unitId: string;
  pensionUnitId: string;
  validFrom: GQLScalar_Date;
  validTo?: GQLScalar_Date | null;
}

export interface GQL_PensionUnitSelectionUpdate {
  id: string;
  pensionUnitId?: string | null;
  validFrom?: GQLScalar_Date | null;
  validTo?: GQLScalar_Date | null;
}

export interface GQL_ProductActivePeriodCreate {
  activeFrom: GQLScalar_Date;
  activeTo?: GQLScalar_Date | null;
}

export interface GQL_ProductActivePeriodUpdate {
  activeFrom?: GQLScalar_Date | null;
  activeTo?: GQLScalar_Date | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_ProductFilter {
  number?: string | null;
  exactNumber?: string | null;
  numberAndName?: string | null;
  name?: string | null;
  productGroupId?: string | null;
  car?: string | null;
  project?: string | null;
  department?: string | null;
  createdBy?: string | null;
  supplierUnitId?: string | null;
  activeDate?: string | null;
  withAnySupplier?: boolean | null;
}

export interface GQL_ProductGroupCreate {
  name: string;
  description?: string | null;
  parentGroupId?: string | null;
  unitId: string;
}

export interface GQL_ProductGroupUpdate {
  name?: string | null;
  description?: string | null;
  parentGroupId?: string | null;
  id: string;
}

export interface GQL_ProductPriceCreate {
  validFrom: GQLScalar_Date;
  validTo?: GQLScalar_Date | null;
  purchasePrice: GQLScalar_Decimal;
  salePrice: GQLScalar_Decimal;
}

export interface GQL_ProductPriceUpdate {
  validFrom?: GQLScalar_Date | null;
  validTo?: GQLScalar_Date | null;
  purchasePrice?: GQLScalar_Decimal | null;
  salePrice?: GQLScalar_Decimal | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_ProductVariantCreate {
  name: string;
  productId: string;
}

export interface GQL_ProductVariantHolderCreate {
  name: string;
  attributeName: string;
  description?: string | null;
  unitId: string;
  variants: GQL_ProductVariantCreate[];
}

export interface GQL_ProductVariantHolderUpdate {
  name?: string | null;
  attributeName?: string | null;
  description?: string | null;
  id: string;
  variants?: GQL_ProductVariantUpdate[] | null;
}

export interface GQL_ProductVariantUpdate {
  name?: string | null;
  productId?: string | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_RecurringOrderSettingBase {
  id?: string | null;
  active?: boolean | null;
  startDate?: GQLScalar_Date | null;
  endDate?: GQLScalar_Date | null;
  dateOffset?: number | null;
  interval?: string | null;
}

export interface GQL_SettingsVacationMoneyReportSave {
  unitId: string;
  year: number;
  excludePositiveAmountsTo?: GQLScalar_Decimal | null;
  excludeNegativeAmountsTo?: GQLScalar_Decimal | null;
}

export interface GQL_UnitCreate {
  isCompany: boolean;
  name: string;
  unofficialName?: string | null;
  address: string;
  city: string;
  zip: string;
  countryCode: string;
  identities: GQL_IdentityCreate[];
}

export interface GQL_UnitInvoiceSettingBase {
  usesKid?: boolean | null;
  kidLength?: number | null;
  kidModDigit?: number | null;
  customerCreditDays?: number | null;
  startingOrderNumber?: number | null;
  startingInvoiceNumber?: number | null;
  customerCountryCode?: string | null;
  currencyCode?: string | null;
  legalNotes?: string[] | null;
  customNote?: string | null;
  displaySettings?: GQL_UnitSettingDisplaySettingBase | null;
  defaultProductUnitOfMeasureCode?: string | null;
  invoiceEmailCopy?: boolean | null;
  supplierPartyReferenceSetting?: GQL_SupplierPartyReferenceSettingEnum | null;
  exports?: boolean | null;
  productGroups?: boolean | null;
  paymentMethods?: boolean | null;
  taxInclusiveAmountRounding?: GQL_RoundingTypeEnum | null;
  usesOverdueNotices?: boolean | null;
  overdueNoticeCharge?: GQLScalar_Decimal | null;
  usesInterestInvoices?: boolean | null;
  efakturaEnabled?: boolean | null;
  orderSaveLockConfirmation?: boolean | null;
}

export interface GQL_UnitPaycheckSettingBase {
  currencyCode?: string | null;
  startingPaycheckNumber?: number | null;
  municipalityId?: string | null;
  calculationForTax?: string | null;
  altinn3AuthAs?: string | null;
  defaultCreditDays?: number | null;
  defaultVacationMoneyPercentage?: GQLScalar_Decimal | null;
  defaultWorkRelation?: GQL_UnitSettingDefaultWorkRelationBase | null;
}

export interface GQL_UnitSettingBase {
  unitId: string;
  logo?: GQLScalar_FileUpload | null;
  unitInvoiceSetting?: GQL_UnitInvoiceSettingBase | null;
  unitPaycheckSetting?: GQL_UnitPaycheckSettingBase | null;
  companyNameOption?: GQL_CompanyNameOptionEnum | null;
}

export interface GQL_UnitSettingDefaultWorkRelationBase {
  subUnitId?: string | null;
  occupationId?: string | null;
  employmentType?: GQL_AltinnEmploymentTypeEnum | null;
  durationType?: GQL_AltinnEmploymentDurationTypeEnum | null;
  shiftType?: GQL_AltinnShiftTypeEnum | null;
  hoursEveryWeekWithFullEmployment?: GQLScalar_Decimal | null;
  employmentPercentage?: GQLScalar_Decimal | null;
}

export interface GQL_UnitSettingDisplaySettingBase {
  invoiceLineCar: boolean;
  invoiceLineProject: boolean;
  invoiceLineDepartment: boolean;
  invoiceLineOrderedQuantity: boolean;
  invoiceLineTaxAmount: boolean;
  invoiceLineAllowanceCharge: boolean;
  invoiceAllowanceCharge: boolean;
  invoiceCar: boolean;
  invoiceProject: boolean;
  invoiceDepartment: boolean;
}

export interface GQL_UserEmployee {
  login?: string | null;
  cellphone: string;
  cellphoneCountryCode?: string | null;
}

export interface GQL_WarehousePatchCreate {
  unitId: string;
  supplierUnitId?: string | null;
  comment?: string | null;
  date: GQLScalar_Date;
  warehousePatchLines: GQL_WarehousePatchLineCreate[];
}

export interface GQL_WarehousePatchLineCreate {
  productId: string;
  quantity: GQLScalar_Decimal;
  purchasePrice: GQLScalar_Decimal;
  productNumber: string;
  productName: string;
  checkpoint: boolean;
}

export interface GQL_WarehousePatchLineUpdate {
  productId?: string | null;
  quantity?: GQLScalar_Decimal | null;
  purchasePrice?: GQLScalar_Decimal | null;
  productNumber?: string | null;
  productName?: string | null;
  checkpoint?: boolean | null;
  id?: string | null;
  _destroy?: boolean | null;
}

export interface GQL_WarehousePatchUpdate {
  unitId?: string | null;
  supplierUnitId?: string | null;
  comment?: string | null;
  date?: GQLScalar_Date | null;
  id: string;
  warehousePatchLines?: GQL_WarehousePatchLineUpdate[] | null;
}

export interface GQL_WebstoreApiTokenCreate {
  unitId: string;
  expiryDate?: GQLScalar_Date | null;
  description: string;
}

export interface GQL_WorkRelationEmployeeSave {
  occupationId?: string | null;
  startDate?: GQLScalar_Date | null;
  endDate?: GQLScalar_Date | null;
  pensionEndDate?: GQLScalar_Date | null;
  endReason?: GQL_AltinnEmploymentEndReasonEnum | null;
  samePositionSince?: GQLScalar_Date | null;
  shiftType?: GQL_AltinnShiftTypeEnum | null;
  employmentType?: GQL_AltinnEmploymentTypeEnum | null;
  employmentPercentage?: GQLScalar_Decimal | null;
  employmentPercentageUpdated?: GQLScalar_Date | null;
  hoursEveryWeekWithFullEmployment?: GQLScalar_Decimal | null;
  lastSalaryChange?: GQLScalar_Date | null;
  durationType?: GQL_AltinnEmploymentDurationTypeEnum | null;
  id?: string | null;
  subUnitId?: string | null;
  _destroy?: boolean | null;
  leaveAndLayoffs?: GQL_WorkRelationLeaveAndLayoffSave[] | null;
}

export interface GQL_WorkRelationLeaveAndLayoffSave {
  id?: string | null;
  _destroy?: boolean | null;
  startDate?: GQLScalar_Date | null;
  endDate?: GQLScalar_Date | null;
  percentageLeave?: GQLScalar_Decimal | null;
  leaveId?: string | null;
  description?: GQL_AltinnLeaveAndLayoffDescriptionEnum | null;
}

export interface GQL_WorkRelationTimesheetBreakInput {
  startHhmm?: string | null;
  endHhmm?: string | null;
}

export interface GQL_WorkRelationTimesheetDayInput {
  date: GQLScalar_Date;
  startHhmm?: string | null;
  endHhmm?: string | null;
  breakMinutes?: number | null;
  breaks?: GQL_WorkRelationTimesheetBreakInput[] | null;
  timeStamps?: GQL_WorkRelationTimesheetDayTimeStampInput[] | null;
  totalMinutes?: number | null;
  paidMinutes?: number | null;
}

export interface GQL_WorkRelationTimesheetDayTimeStampInput {
  key: string;
  startHhmm?: string | null;
  endHhmm?: string | null;
}

export interface GQL_WorkRelationTimesheetSaveAttributes {
  workRelationId: string;
  calendarMonth: string;
  days: GQL_WorkRelationTimesheetDayInput[];
  timeStamps?: GQL_WorkRelationTimesheetTimeStampInput[] | null;
  totalMinutesSum: number;
  paidMinutesSum: number;
}

export interface GQL_WorkRelationTimesheetTimeStampInput {
  key: string;
  name: string;
  totalMinutes?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
